/**
 * Positions the cursor at the end of an input field and scrolls to show the end of the text.
 * Useful for focus events where you want to ensure the cursor is at the end.
 *
 * @param target - The input element to position cursor in
 */
export function handleInputFocusWithCursorPositionEnd(event: FocusEvent): void {
	const target = event.target as HTMLInputElement;

	if (!target) return;

	// Use requestAnimationFrame to ensure the DOM is updated
	requestAnimationFrame(() => {
		const len = target.value.length;
		target.setSelectionRange(len, len);
		target.scrollLeft = target.scrollWidth;
	});
}